import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children, token }) => {
    const [socket, setSocket] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState(new Set());
    const socketRef = useRef(null);

    useEffect(() => {
        if (!token) return;

        const SERVER_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || undefined;

        const newSocket = io(SERVER_URL, {
            auth: { token },
            withCredentials: true
        });

        socketRef.current = newSocket;

        newSocket.on('connect', () => {
            console.log('Socket connected:', newSocket.id);
            setSocket(newSocket);
        });

        newSocket.on('user_online', (userId) => {
            setOnlineUsers(prev => {
                const updated = new Set(prev);
                updated.add(userId);
                return updated;
            });
        });

        newSocket.on('user_offline', (userId) => {
            setOnlineUsers(prev => {
                const updated = new Set(prev);
                updated.delete(userId);
                return updated;
            });
        });

        newSocket.on('disconnect', () => {
            console.log('Socket disconnected');
            setSocket(null);
        });

        return () => {
            newSocket.disconnect();
            socketRef.current = null;
        };
    }, [token]);

    return (
        <SocketContext.Provider value={{ socket: socketRef.current, onlineUsers }}>
            {children}
        </SocketContext.Provider>
    );
};
